// Quality Badges Section
$(function () {
    // Flickity for quality badges
    const $qualityBadgesCarousel = $(
        ".QualityBadges.Carousel[data-flickity-config]"
    );
    if ($qualityBadgesCarousel.length) {
        const options = $qualityBadgesCarousel.data("flickity-config");
        $qualityBadgesCarousel.flickity(options);
    }
});


// Scientific Studies section now uses theme-native Swiper (see scientific-studies.liquid).